var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40.4829C8.954 40.4829 0 31.5289 0 20.4829C0 9.43691 8.954 0.48291 20 0.48291C31.046 0.48291 40 9.43691 40 20.4829C40 31.5289 31.046 40.4829 20 40.4829ZM20 36.4829C24.2435 36.4829 28.3131 34.7972 31.3137 31.7966C34.3143 28.796 36 24.7264 36 20.4829C36 16.2394 34.3143 12.1698 31.3137 9.1692C28.3131 6.16862 24.2435 4.48291 20 4.48291C15.7565 4.48291 11.6869 6.16862 8.68629 9.1692C5.68571 12.1698 4 16.2394 4 20.4829C4 24.7264 5.68571 28.796 8.68629 31.7966C11.6869 34.7972 15.7565 36.4829 20 36.4829ZM22 20.4829H30V24.4829H18V10.4829H22V20.4829Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector-3.736f1065eeef6e429f05114e36e4d592.svg";
export { ForwardRef as ReactComponent };